import EditProfile from '../pages/EditProfile.jsx';
import General from '../pages/General.jsx';
import Security from '../pages/Security.jsx';

const baseRoutes = [
  {
    key: 'general',
    path: 'general',
    title: 'User Profile',
    navLabel: 'User Profile',
    navIcon: 'home',
    navKey: 'general',
    component: General,
    headerAction: { label: 'Edit Profile', target: 'edit' }
  },
  {
    key: 'security',
    path: 'security',
    title: 'Security',
    navLabel: 'Security',
    navIcon: 'shield',
    navKey: 'security',
    component: Security
  },
  {
    key: 'edit',
    path: 'edit-profile',
    title: 'User Profile',
    navLabel: 'My Account',
    navKey: 'general',
    component: EditProfile,
    headerAction: { label: 'Save', target: 'general' },
    headerSecondaryAction: { label: 'Cancel', target: 'general' }
  }
];

export const routes = baseRoutes.map(route => ({
  ...route,
  hash: `#/${route.path}`
}));

export const navRoutes = routes.filter(route => route.navLabel && route.key !== 'edit');
export const defaultRouteKey = 'general';

export const routeMap = routes.reduce((map, route) => {
  map[route.key] = route;
  map[route.path] = route;
  return map;
}, {});

export const parseHash = hashValue => {
  const cleanHash = hashValue.replace(/^#\/?/, '').replace(/\/$/, '').toLowerCase();
  if (!cleanHash) return routeMap[defaultRouteKey];
  return routeMap[cleanHash] || routeMap[defaultRouteKey];
};

export const getHashForKey = key => (routeMap[key] || routeMap[defaultRouteKey]).hash;
